import tw, { styled } from "twin.macro";

export const SplitPaneWrapper = styled.div`
	width: 100%;
	overflow-y: auto;
	height: ${({ mainHeightAdjust }) =>
		mainHeightAdjust
			? `calc(
		100vh - ${mainHeightAdjust})`
			: `calc(
		100vh - 3rem)`};
	@media (max-width: 768px) {
		height: ${({ mainHeightAdjust, heightAuto }) =>
			mainHeightAdjust
				? `calc(
		100vh - ${mainHeightAdjust})`
				: heightAuto
				? "auto"
				: `calc(
		100vh - 3rem)`};
	}
	-ms-overflow-style: none !important; /* IE and Edge */
	scrollbar-width: none !important;
	&::-webkit-scrollbar {
		display: none !important;
	}
`;

export const SplitPaneContent = styled.div`
	${tw`w-full m-0 gap-4`}
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	overflow: hidden;
	@media (max-width: 1217px) {
		${({ direction }) => direction && `flex-direction: ${direction}`}
	}

	-ms-overflow-style: none !important; /* IE and Edge */
	scrollbar-width: none !important;
	&::-webkit-scrollbar {
		display: none !important;
	}
`;

export const SplitLeft = styled.div`
	overflow-y: scroll;
	flex: 2;
	width: 100%;
	height: ${({ leftHeightAdjust }) =>
		leftHeightAdjust
			? `calc(
		100vh - ${leftHeightAdjust})`
			: `calc(
		100vh - 3rem)`};
	@media (max-width: 1217px) {
		width: 100%;
		padding: 0px;
	}

	-ms-overflow-style: none !important; /* IE and Edge */
	scrollbar-width: none !important;
	&::-webkit-scrollbar {
		display: none !important;
	}
`;

export const SplitRight = styled.div`
	flex: 1;
	overflow-y: auto;
	width: 100%;
	height: ${({ rightHeightAdjust }) =>
		rightHeightAdjust
			? `calc(
		100vh - ${rightHeightAdjust})`
			: `calc(
		100vh - 3rem)`};
	${({ hide }) => hide && `display: none;`};

	-ms-overflow-style: none !important; /* IE and Edge */
	scrollbar-width: none !important;
	&::-webkit-scrollbar {
		display: none !important;
	}
`;
